export function roundTo(n, place) {
    if (Number.isNaN(n)) return n;
    return +(Math.round(n + "e+" + place) + "e-" + place);
}

